import * as yup from 'yup'
import translation from 'i18next'
import { mediaSchema } from '@/components/inputs'
import {
  FOG_LEVEL_MIST_BOVEN_WATERGANGEN,
  FOG_LEVEL_DICHTE_MIST,
} from '@/constants'

export const visitLogInfoSchema = yup.object({
  start_datetime: yup.date().typeError('invalid_date').required().nullable(),
  end_datetime: yup.date().typeError('invalid_date').required().nullable(),
  start_temperature: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
  end_temperature: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
  wind_force: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
  cloud_cover: yup.string().required(),
  precipitation: yup.string().required(),
  precipitation_duration: yup.string().required(),
  fog_level: yup.string().required(),
  fog_duration: yup.string().when('fog_level', {
    is: (val: string) =>
      val === FOG_LEVEL_MIST_BOVEN_WATERGANGEN || val === FOG_LEVEL_DICHTE_MIST,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  photos: mediaSchema,
})
